module.exports = __webpack_public_path__ + "static/media/Main_subcontent2.77d9054b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_subcontent2.jpeg
// module id = 213
// module chunks = 0